import React, { useCallback, useMemo, useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify'
import { VacationForm } from './VacationForm'

export const parseIntNaN = (value, defaultValue = 0) => {
  return isNaN(parseInt(value)) ? defaultValue : parseInt(value);
}


export const Vacation = () => {
  const [isProcessing, setIsProccesing] = useState(true)
  const [reload, setReload] = useState(true)
  const [rows, setRows] = useState([])
  const [worker, setWorker] = useState({})
  const [modalShow, setModalShow] = useState(false)

  useEffect(() => {
    if (reload) {
      setIsProccesing(true)
      Controllers.vacation.get_my().then(res => {
        setRows(res.data?.vacations || [])
        setWorker(res.data?.worker || {})
      }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => {
        setIsProccesing(false)
        setReload(false)
      })
    }
  }, [reload])

  const daysVacation = useCallback(() => {
    return parseIntNaN(worker?.vacations_left_days, 0)
  }, [worker])

  const handleOpenCreate = () => setModalShow(true)
  const handleCloseModal = () => setModalShow(false)

  const handleDelete = (id_vacation) => {
    Controllers.vacation.delete({ p_id_vacation: id_vacation }).then(res => {
      Helpers.toast.construct({ ...res, toast })
      if (res.response === 'success') {
        setReload(true)
      }
    }).catch(req => Helpers.promise.catch({ req, toast }))
  }

  const dtRows = useMemo(() => <ReactDataTableBootstrap
    head={[[
      { name: 'full_name_worker', text: 'Trabajador', align: 'center' },
      { name: 'from_date', text: 'Fecha Inicio', align: 'center' },
      { name: 'to_date', text: 'Fecha Fin', align: 'center' },
      { name: 'vacation_days', text: 'Días', align: 'center' },
      { name: 'request_comments', text: 'Solicitud', align: 'center' },
      { name: 'status_vacation', text: 'Estado', align: 'center' },
      { name: 'comments', text: 'Comentarios', align: 'center' },
      { name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
        return <div>
          {u.status_vacation !== 'APPROVED' && <Button variant="danger" size="xs" onClick={() => handleDelete(u.id_vacation)}>
            <i className="fa fa-trash"></i>
          </Button>}
        </div>
      }},
    ]]}
    rows={rows}
    isProcessing={isProcessing}
  />, [rows, isProcessing])

  return <div className='form-row'>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10">
      <Card>
        <Card.Body>
          <div className='mb-3 alert alert-info '>Días de vacaciones disponibles: <strong>{daysVacation()}</strong></div>
          {daysVacation() > 0 && <div className="mb-3">
            <Button size="sm" onClick={handleOpenCreate}>
              <i className="fa fa-plus mr-1"></i> Registrar Solicitud
            </Button>
          </div>}
          {dtRows}
        </Card.Body>
      </Card>
    </div>
    <Modal show={modalShow} onHide={handleCloseModal} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title as="div">Registrar Solicitud</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <VacationForm
          vacationLeftDays={daysVacation()}
          journeyWorker={worker?.journey_worker}
          setReload={() => {
            setReload(true)
            setModalShow(false)
          }}
        />
      </Modal.Body>
    </Modal>
  </div>
}

export default Vacation

